import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-snackbar-message',
  templateUrl: './snackbar-message.component.html',
  styleUrls: ['./snackbar-message.component.css']
})
export class SnackbarMessageComponent implements OnInit {
  message: string;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string, center }
  ) { }

  ngOnInit(): void {
    this.message = this.data ? this.data.message : "";
  }

}
